module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "u49OgEGmahNfkAXxyKZ7ha3",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "ulsLYIotsc849tgTQguTfFG"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("First and foremost, I’d like to thank my wife for her unending support.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I’d also like to thank the team at WildBlue Press including Steve Jackson, Michael Cordova, Stephanie Johnson Lawson, Jazzminn Morecraft, and Jenn Waterman. They have been a pleasure to work with.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When I began this book, the first thing I needed was the police reports from 1960. Using the Freedom of Information Act, I submitted my request to the Michigan State Police and was excited when I received a telephone call and was told they had the documents I had requested. I was excited to know they had them, and pleasantly surprised to find out the person who was processing my request was a fan of my books. Thank you, Missy S. and the Michigan State Police.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There are very few people left who had direct knowledge of the investigation, and that meant there were few people to interview. I did a book presentation at St. Luke’s Lutheran Church in Haslett, Michigan, and by chance, I had the pleasure of meeting retired MSP Laboratory Specialist Walter Holz. Walter worked for MSP in the early sixties when the crime lab was part of the Michigan Department of Public Health, and he worked closely with Dr. Edgar Kivela, the scientist directly involved in analyzing the trace evidence in this case. Walter Holz was instrumental in describing how the crime lab was set up at the time and how evidence was stored.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Part of my research for this book was a two-day visit to Mackinac Island. After checking in at the same hotel where Frances Lacey stayed, I walked to the murder scene along Lake Shore Road for photos and measurements, and I ended the day at the library. I’d like to thank Shepler’s Ferry, the Mackinac Island Tourism Bureau, the Mackinac Island Public Library, Horn’s Bar, the Great Turtle Brewery, the Island Bookstore, the Pink Pony, and the Murray Hotel.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I was lucky enough to have had the pleasure of speaking with a few Island residents who recalled those frightening days following the murder, and I’d like to thank them while at the same time protecting their privacy by not listing their names here.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In a book titled "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Mackinac Island: Inside, Up Close, and Personal, ")]), _vm._v("author Dennis O. Cawthorne describes life on Mackinac Island from the time he arrived in 1960 and beyond. I reached out to Dennis, and he graciously returned my call. I was poised to bombard him with a list of questions, and he suggested I read his book first. He said it would probably answer the majority of the questions I was going to ask, and it did. I truly enjoyed the historical information he offered in both the book and in a follow-up phone call.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Inspector Phil Shertzing (MSP, retired), an MSP historian, was a great help in providing me with information about where to find both crime scene photos and personnel photos of the original investigators.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Finally, to Ryan Wilkinson, Ken Ouellette, Chuck Loader, Vince Green, Greg Michaud, and Elizabeth Walby, thank you for the ideas, suggestions, and tidbits of information that pointed me in the right direction.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c179308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Ack.vue
// module id = 81
// module chunks = 0